import * as React from 'react';
/**
 * @ignore - internal component.
 */

var FormControlContext = /*#__PURE__*/React.createContext();

if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}

export function useFormControl() {
  return React.useContext(FormControlContext);
}
export default FormControlContext;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/FormControl/FormControlContext.js
// module id = 452
// module chunks = 121